import React, { Component } from 'react';
import { BounceLoader } from 'react-spinners';
import { Field } from 'redux-form';
import classNames from 'classnames';
import { states, suffixes } from '../../common/lib/generateStates';
import RenderField from '../../common/components/Form/RenderField';
import BannerFormErrors from '../../common/components/Form/BannerFormErrors';
import Button from '../../common/components/Button';
import {
  phone,
  normalizePhone,
  normalizeZip,
  required,
  state,
  zipcode,
  noSpecialChars,
  normalizeName,
  getAlphabeticOrder,
  cityMaxLength,
} from '../../common/lib/validation';

import { CITY_HELP_TEXT } from '../../common/lib/constants';

import '../../../style/index.css';
import './complete-registration.css';

class RegisterForm extends Component {
  render() {
    const {
      submitFormFn,
      registrationFailed,
      formSubmissionError,
      errorDetail,
      statusCode,
      isFetching,
      formRef,
    } = this.props;

    return (
      <form className="needs-validation" noValidate ref={formRef}>
        <div className="personal-info-wrap personal-info-wrap--first">
          <h2 className="form-header">Personal Information</h2>
          <Field
            name="firstName"
            type="text"
            component={RenderField}
            label="Legal First Name*"
            validate={required}
            normalize={normalizeName}
          />
          <Field
            name="middleName"
            type="text"
            component={RenderField}
            label="Middle Name"
            normalize={normalizeName}
          />
          <Field
            name="lastName"
            type="text"
            component={RenderField}
            label="Last Name*"
            validate={required}
            normalize={normalizeName}
          />
          <Field
            name="suffix"
            type="select"
            options={suffixes}
            component={RenderField}
            label="Suffix"
            defaultSelectValue="Select Suffix"
          />
          <Field
            name="streetNumber"
            type="text"
            component={RenderField}
            label="House/Building Number*"
            validate={required}
            placeholder="Ex: 123"
            normalize={noSpecialChars}
          />
          <Field
            name="street"
            type="text"
            component={RenderField}
            label="Street Name*"
            validate={required}
            placeholder="Ex: Main Street"
          />
          <Field
            name="addressLine2"
            type="text"
            component={RenderField}
            label="Apartment/Floor/Other"
            placeholder="Ex: Apartment 2, Floor 3, etc (Optional)"
          />
          <Field
            name="city"
            type="text"
            component={RenderField}
            label="City/Town*"
            validate={[cityMaxLength, required]}
            helpText={CITY_HELP_TEXT}
          />
          <Field
            name="state"
            type="select"
            component={RenderField}
            label="State*"
            options={getAlphabeticOrder(states)}
            validate={state}
            defaultSelectValue="Select State"
          />
          <Field
            name="zip"
            type="text"
            component={RenderField}
            label="Zip Code*"
            validate={zipcode}
            normalize={normalizeZip}
            helpText="Enter 5 digits, or 5 digits, a hyphen, and 4 more digits (for example, 12345 or 12345-6789)."
          />
          <Field
            name="phone"
            type="tel"
            component={RenderField}
            label="Phone Number*"
            placeholder="(XXX) XXX-XXXX"
            validate={phone}
            normalize={normalizePhone}
            prepend="phone"
            className="has-prepend"
            inputmode="tel"
            helpText="Use 10 digits; the field will format as (XXX) XXX-XXXX."
          />

          <BannerFormErrors
            apiFailed={registrationFailed}
            errorDetail={errorDetail}
            statusCode={statusCode}
            formSubmissionError={formSubmissionError}
          />

          <div className="button-wrap">
            {isFetching ? (
              <div className="loading-wrapper">
                <BounceLoader color="#084267" />
              </div>
            ) : (
              <Button
                label="Register"
                onClickFn={submitFormFn}
                className={classNames('nyl-button', { 'button-error': registrationFailed || formSubmissionError })}
                id="register-button"
              />
            )}
          </div>
          <noscript>
            <img
              src="https://ad.doubleclick.net/ddm/activity/src=5139115;type=nylot0;cat=nylre0;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;npa=;gdpr=${GDPR};gdpr_consent=${GDPR_CONSENT_755};ord=1?"
              width="1"
              height="1"
              alt=""
            />
          </noscript>
        </div>
      </form>
    );
  }
}

export default RegisterForm;
